<template>
  <div id="app">
    <WebsiteHeader/>
    <!-- 路由出口：各个页面的内容会在这里渲染，头部始终常驻 -->
    <router-view style="margin-top: 100px; padding: 0 20px;min-height: calc(100vh - 230px);" />
    <WebsiteFooter/>
  </div>
</template>

<script>
// import home from './home/index.vue'
// 引入 Header 组件（优先使用 @ 别名，避免路径错误）
import WebsiteHeader from './components/header.vue'
import WebsiteFooter from './components/footer.vue'

export default {
  name: 'App',
  components: {
    WebsiteHeader,
    WebsiteFooter
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>
